// Global map to store waveform pointers (updated by EditorPanel/InlineEditor)
export const waveformPointersMap = new Map<number, { bufferPtr: number; writePosition: number }>()

// Global map to store offscreen canvases (persists across widget recreations)
// Keyed by a context-specific id to avoid sharing content across tabs/tracks.
export const waveformCanvases = new Map<string, {
  canvas: OffscreenCanvas | HTMLCanvasElement
  ctx: OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D
}>()

// Global map to store read offsets (persists across widget recreations)
// Keyed by the same context-specific id as waveformCanvases.
export const waveformReadOffsets = new Map<string, number>()

// Global map to store previous level values for gravity fall effect
// Keyed by the same context-specific id as waveformCanvases.
export const levelPreviousValues = new Map<string, { peak: number; peakLine: number }>()

export interface DragState {
  key: string
  value: number
  min: number
  max: number
  line: number
  column: number
  length: number
  x: number
  y: number
  width: number
  isDragging: boolean
}

export interface Handlers {
  move: ((e: PointerEvent) => void) | null
  up: (() => void) | null
}

export const updateValueWithSpacing = (
  line: string,
  column: number,
  oldValueStr: string,
  newValue: number,
  totalLength: number,
): string => {
  const before = line.substring(0, column - 1)
  const after = line.substring(column - 1 + oldValueStr.length)

  const minMaxMatch = after.match(/^(\s*)(\(min:(-?[\d.]+),\s*max:(-?[\d.]+)\))/)
  const minMaxPart = minMaxMatch ? minMaxMatch[2] : ''
  const existingSpaces = minMaxMatch ? minMaxMatch[1] : ''
  const restAfter = minMaxMatch ? after.substring(minMaxMatch[0].length) : after

  let maxDecimals = 3
  if (minMaxMatch) {
    const minStr = minMaxMatch[3]
    const maxStr = minMaxMatch[4]
    const minDecimalPlaces = minStr.includes('.') ? minStr.split('.')[1]?.length ?? 0 : 0
    const maxDecimalPlaces = maxStr.includes('.') ? maxStr.split('.')[1]?.length ?? 0 : 0
    maxDecimals = Math.max(minDecimalPlaces, maxDecimalPlaces)
  }

  let newValueStr = maxDecimals > 0
    ? newValue.toFixed(maxDecimals)
    : Math.round(newValue).toString()

  if (maxDecimals > 0 && Math.abs(newValue) < 1 && newValue !== 0) {
    newValueStr = newValueStr.replace(/^(-?)0\./, '$1.')
  }

  const spacesNeeded = Math.max(0, totalLength - newValueStr.length - minMaxPart.length)
  const spaces = ' '.repeat(spacesNeeded)

  return before + newValueStr + spaces + minMaxPart + restAfter
}
